module.exports = "../dist/img/white-39.d6c8.jpg";